const config = {
  // userManagement: 'https://meribachat.in/um',
  // rewardManagement: 'https://meribachat.in/rm',
  meribachat: 'https://meribachat.in/mb-be',
  // meribachatfrontend: 'https://meribachat.in',
  // userManagement: 'http://localhost:8000',
  rewardManagement: 'https://test.meribachat.in/rm',
  userManagement: 'https://test.meribachat.in/um',
  // meribachat: 'https://test.meribachat.in/mb-be',
  meribachatfrontend: 'http://localhost:3000',
  affiliate: 'https://test.meribachat.in/affiliate',
  // affiliate: 'http://localhost:3003',
  maxPercent: 10,
  maxAmmount: 100,
  maxSuperPercent: 5,
  minWalletBalance: 50
}

export default config
